import NavbarElement from '../components/sidebar/navbar';
import Sidebar from '../components/sidebar/sidebar';
import classNames from 'classnames';
import React, { useState } from 'react';
import RfqTable from '../components/rfqs/rfq-table';
import FloatingButton from '../components/floating-button';
import QuoteDefaultsModal from '../components/rfqs/quote-defaults-modal';
import AddNewRfqComponent from '../components/rfqs/add-new-rfq';
import ViewRfqComponent from '../components/rfqs/rfqs-display-modal';
import { updateRFQ } from '../database/set-rfq-data';
import { useNavigate, useLocation } from 'react-router-dom';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function RFQsPage(props) {
  const [collapsed, setSidebarCollapsed] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openDefaultsModal, setOpenDefaultsModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const navigate = useNavigate();
  const query = useQuery();

  // Open modal if ?id= is present in URL
  React.useEffect(() => {
    const id = query.get('id');
    if (id) {
      setSelectedId(id);
      setOpenEditModal(true);
    } else {
      setOpenEditModal(false);
      setSelectedId(null);
    }
  }, [query]);

  // Handler for the "eye" button
  const handleViewClick = (docId) => {
    navigate(`/rfq?id=${docId}`);
    // The useEffect above will open the modal
  };

  // Handler for closing the modal
  const handleCloseModal = () => {
    setOpenEditModal(false);
    setSelectedId(null);
    navigate('/rfq'); // Remove the id from the URL
  };

  const handleRFQUpdate = async () => {
    updateRFQ('d6c86583-c869-4f38-9455-f4fb456921f6', {
      rfqNo: '10758540',
    });
  };

  return (
    <div
      className={classNames({
        'grid bg-zinc-100 min-h-screen': true,
        'grid-cols-sidebar': !collapsed,
        'grid-cols-sidebar-collapsed': collapsed,
        'transition-[grid-template-columns] duration-300 ease-in-out': true,
      })}
    >
      <div
        style={{
          display: 'flex',
        }}
      >
        <div>
          <Sidebar
            collapsed={collapsed}
            setCollapsed={setSidebarCollapsed}
            shown={showSidebar}
          />
        </div>
        <div className="container 2xl:max-w-full" style={{ overflow: 'auto' }}>
          <div className="h-screen flex flex-col">
            <NavbarElement
              onMenuButtonClick={() => setShowSidebar((prev) => !prev)}
            />
            {/* <button onClick={handleRFQUpdate}>Update RFQ</button> */}
            <div className="flex-grow overflow-hidden">
              <RfqTable
                setOpenEditModal={setOpenEditModal}
                openEditModal={openEditModal}
                setSelectedId={setSelectedId}
                onViewClick={handleViewClick}
              />
            </div>
          </div>
          <div className="fixed right-4 bottom-4 flex flex-col sm:flex-row gap-2 items-end">
            <FloatingButton fixed={false} onClick={() => setOpenDefaultsModal(true)} text={'Set Margin & G&A'} />
            <FloatingButton fixed={false} onClick={() => setOpenModal(true)} text={'Add New RFQ'} />
          </div>
          <AddNewRfqComponent
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
          <QuoteDefaultsModal open={openDefaultsModal} setOpen={setOpenDefaultsModal} />
          <ViewRfqComponent
            openEditModal={openEditModal}
            setOpenEditModal={handleCloseModal}
            docId={selectedId}
          />
        </div>
      </div>
    </div>
  );
}

export default RFQsPage;
